import DepartmentWarehouseList from '@/components/DepartmentWarehouse/DepartmentWarehouseList'

let DepartmentWarehouseRouter = [{
  path: '/department-warehouse',
  name: 'DepartmentWarehouseList',
  component: DepartmentWarehouseList,
  meta: {
    title: 'Affectation département → entrepôt',
    requiresAuth: true,
    authorizations: ['department-warehouse_index', 'desktop_access']
  }
}]

export default DepartmentWarehouseRouter



// WEBPACK FOOTER //
// ./src/components/DepartmentWarehouse/router.js